import ApiClient from "@/api/ApiClient.ts";

const state = {
  stops: null,
};

const mutations = {
  setStops(state, stops) {
    state.stops = stops;
  },
};

const actions = {
  async getStops({ commit }, idWorkgroup) {
    const params = {
      wgId: idWorkgroup,
    };
    try {
      const api = ApiClient();
      let response = await api.get("stops", { params });
      commit("setStops", response.data);
    } catch (error) {
      console.error("ERROR en getStops: ", error.message);
    }
  },
};

const getters = {
  stops(state) {
    return state.stops;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
